<app-model-pj-file [downloadOnly]="downloadOnly"></app-model-pj-file>

<div *ngIf="!downloadOnly">
  <app-model-pj-type></app-model-pj-type>
</div>
